import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export function getLocationTabNavigationProps(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.CARDIT_NESTING_LOCATION_801.id,
    mainReportId: ReportDefinitions.CARDIT_NESTING_DETAILS_801.id,
    requestParams: {
      operator: rowInfo.row['cardit.carrier'],
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    ExternalConsignmentLinkColumn,
    ExternalReceptacleLinkColumn,
  } = columns(data);

  return [
    {
      Header: 'CARDIT',
      columns: [
        new ExternalConsignmentLinkColumn(new TextColumn('Consignment ID', 'cardit.consignmentId')),
        new ExternalReceptacleLinkColumn(new TextColumn('Receptacle ID', 'cardit.receptacleId').withWidth(275)),
        new DateTimeColumn('Completion date', 'cardit.completionDate'),
        new TextColumn('Sender', 'cardit.sender'),
        new TextColumn('Receiver', 'cardit.receiver'),
        new TextColumn('Mail category', 'cardit.mailCategory'),
        new TextColumn('Origin country', 'cardit.originCountry'),
        new TextColumn('Origin airport', 'cardit.originAirport'),
        new TextColumn('Destination country', 'cardit.destinationCountry'),
        new TextColumn('Destination airport', 'cardit.destinationAirport'),
        new TextColumn('First leg conveyance reference', 'cardit.firstLegConveyanceReference'),
        new TextColumn('Last leg conveyance reference', 'cardit.lastLegConveyanceReference'),
        new TextColumn('CJID', 'cardit.cjid'),
        new TextColumn('ULD ID', 'cardit.uldId'),
      ],
    },
  ];
};
